module.exports = __webpack_public_path__ + "static/media/iPhone14_7.5f4cb92f.png";